import { dbsKeys } from "data/dbsKeys";
import { readCollection, writeCollection } from "data/dbsStorage";
import { signOutFirebase } from "data/firebase";

const EMPTY = null;

export const sessionRepo = {
  getSession() {
    return readCollection(dbsKeys.session, EMPTY);
  },

  signIn({ userId, email, displayName, role }) {
    const session = {
      userId: userId || "u-" + Date.now().toString(36),
      email: email || null,
      displayName: displayName || "Kullanıcı",
      role: role || "customer",
    };
    writeCollection(dbsKeys.session, session);
    return session;
  },

  register({ email, password, displayName, role }) {
    return sessionRepo.signIn({ email, password, displayName, role });
  },

  signInAsGuest() {
    return sessionRepo.signIn({ displayName: "Misafir", role: "customer" });
  },

  async signOut() {
    writeCollection(dbsKeys.session, null);
    try {
      await signOutFirebase();
    } catch {
      // Yerel oturum yine de temizlenir.
    }
  },
};
